export const ROUTES = {
  BASE: "/",
  REGISTER: "/register",
  LOGIN: "/login",
  TERMS: "/terms",
  GAMES: "/games",
  DISCLAIMER: "/disclaimer",
  PRIVACY: "/privacy",

  PREDICTOR: "/games/predictor",
  DICE: "/games/dice",
  SPINNERS: "/games/spinners",
  CARD_GAME: "/games/card-game",
};